module.exports = __webpack_public_path__ + "static/media/cubre.f89aa33c.jpg";